import { render, staticRenderFns } from "./loadingGryphon.vue?vue&type=template&id=c6ba6308&scoped=true"
import script from "./loadingGryphon.vue?vue&type=script&lang=js"
export * from "./loadingGryphon.vue?vue&type=script&lang=js"
import style0 from "./loadingGryphon.vue?vue&type=style&index=0&id=c6ba6308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ba6308",
  null
  
)

export default component.exports